import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { LongCard } from '../../components';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import OvertimeCompensationDatatable from '../Profile/OvertimeCompensation/OvertimeCompensationDatatable';
import columns from '../Shared/OvertimeCompensation/Columns';
import { HROvertimeCompensationsRequest } from '../../requests/dashboards';

const OvertimeCompensationIndex = ({
  moreData,
  setMoreData,
  currentEmployee,
  todayMoment = null,
  twoMonthsAgo = null
}) => {
  const [activeCard, setActiveCard] = useState('all');
  const [cards, setCards] = useState({});
  const [customParams, setCustomParams] = useState({});
  const [nameRangePicker, setNameRangePicker] = useState('date_range');
  const [defaultStartDate, setDefaultStartDate] = useState(twoMonthsAgo);
  const [defaultEndDate, setDefaultEndDate] = useState(todayMoment);

  const dispatch = useDispatch();

  const fetchDashboardCards = useCallback(() => {
    HROvertimeCompensationsRequest({
      dispatch,
      successCallback: response => setCards(camelCaseEmptyStringRecursive(response.data))
    });
  }, [dispatch]);

  const handleClick = card => {
    switch (card) {
      case 'requested':
        setCustomParams({ status: 'pending' });
        setNameRangePicker('date_range');
        setActiveCard('requested');
        setDefaultStartDate(setDefaultStartDate);
        setDefaultEndDate(setDefaultStartDate);
        setMoreData(!moreData);
        break;
      case 'approved':
        setCustomParams({ status: 'approved' });
        setNameRangePicker('date_range');
        setActiveCard('approved');
        setDefaultStartDate(setDefaultStartDate);
        setDefaultEndDate(setDefaultStartDate);
        setMoreData(!moreData);
        break;
      case 'rejected':
        setCustomParams({ status: 'rejected' });
        setNameRangePicker('date_range');
        setActiveCard('rejected');
        setDefaultStartDate(setDefaultStartDate);
        setDefaultEndDate(setDefaultStartDate);
        setMoreData(!moreData);
        break;
      default:
        setCustomParams({});
        setNameRangePicker('date_range');
        setActiveCard('all');
        setDefaultStartDate(setDefaultStartDate);
        setDefaultEndDate(setDefaultStartDate);
        setMoreData(!moreData);
        break;
    }
  };

  useEffect(() => {
    fetchDashboardCards();
  }, [moreData, fetchDashboardCards]);

  return (
    <>
      <Row className="mt-3 mb-3">
        <Col md={4} xs={12}>
          <LongCard
            variant="info"
            title={cards.requested || 0}
            label="Días por Horas Extras Solicitadas"
            active={activeCard === 'requested'}
            onClick={() => handleClick('requested')}
          />
        </Col>
        <Col md={4} xs={12}>
          <LongCard
            variant="warning"
            title={cards.approved || 0}
            label="Días por Horas Extras Autorizados"
            active={activeCard === 'approved'}
            onClick={() => handleClick('approved')}
          />
        </Col>
        <Col md={4} xs={12}>
          <LongCard
            variant="danger"
            title={cards.rejected || 0}
            label="Días por Horas Extras Rechazados"
            active={activeCard === 'rejected'}
            onClick={() => handleClick('rejected')}
          />
        </Col>
      </Row>
      <OvertimeCompensationDatatable
        columns={columns}
        customParams={customParams}
        nameRangePicker={nameRangePicker}
        defaultStartDate={defaultStartDate}
        defaultEndDate={defaultEndDate}
        moreData={moreData}
        setMoreData={setMoreData}
        currentEmployee={currentEmployee}
        rrhh
      />
    </>
  );
};

export default OvertimeCompensationIndex;
